import { Field } from "formik"

const Checkbox = ({ label, ...rest }) => (
	<label>
		<Field {...rest} type="checkbox" />
		<span className="ml-1">{label}</span>
	</label>
)

export default Checkbox